export const dailyChest = {
  title: "Daily Chests",
  newCampaign: "New campaign",
  editCampaign: "Edit campaign",
  name: "Name",
  startDate: "Start date",
  endDate: "End date",
  datePlaceholder: "DD/MM/YYYY",
  detail: "Campaign description",
  detailHint: "Text players will see (optional)",
  campaignImage: "Campaign image",
  campaignImageHint: "Image players will see (optional)",
  removeImage: "Remove image",
  status: "Status",
  live: "LIVE",
  draft: "Draft",
  statusScheduled: "Scheduled",
  statusEnded: "Ended",
  statusOff: "Off",
  actions: "Actions",
  edit: "Edit",
  publish: "Publish",
  published: "Published",
  milestones: "Rewards by check-in count",
  addChest: "Add chest",
  collapseAll: "Collapse all",
  expandAll: "Expand all",
  loginCountPrefix: "Check-in",
  loginCountSuffix: "times",
  loginCountLabel: "Check-in count",
  chestName: "Chest name",
  imageUrl: "Chest image",
  clickToUpload: "Click to upload image",
  imageUploaded: "Uploaded — click to change",
  upload: "Upload",
  uploadFailed: "Image upload failed",
  removeChest: "Remove chest",
  rewardPool: "Reward pool",
  reward: "Reward (in cent)",
  turnover: "Turnover (in cent)",
  turnoverHint: "Enter in cent (฿1 = 100), Turnover = the amount the player must wager before this reward can be withdrawn (prevents claim-and-withdraw), 0 = withdrawable immediately",
  dropRate: "Drop rate",
  addReward: "Add reward",
  fillRemainder: "Fill remaining",
  dropHint: "Higher drop rate is drawn more often",
  poolTitle: "Rewards in this chest",
  poolExplainer: "This chest draws 1 reward by the set odds, all drop rates must sum to 100%",
  poolSumLabel: "Total odds",
  rewardsUnit: "rewards",
  save: "Save campaign",
  cancel: "Cancel",
  noCampaigns: "No campaigns yet",
  noPermission: "No permission (DAILY_CHEST.MANAGE)",
  publishConfirmTitle: "Publish campaign",
  publishConfirmMessage: "This campaign will go live and supersede the current active campaign.",
  publishSupersede: "Will supersede the active campaign:",
  publishNoActive: "Will go live immediately (no campaign is currently active).",
  saved: "Saved",
  publishedToast: "Published",
  loadFailed: "Load failed",
  saveFailed: "Save failed",
  publishFailed: "Publish failed",
  inactivate: "Inactivate",
  inactivateConfirmTitle: "Inactivate campaign",
  inactivateConfirmMessage: "This campaign will be turned off — players will have no active daily chest until another is published.",
  inactivatedToast: "Inactivated",
  inactivateFailed: "Inactivate failed",
  sumMustBe100: "Drop rate must sum to 100",
  atLeastOneReward: "Each chest needs at least one reward",
  amountPositive: "Reward amount must be greater than 0",
  dropPositive: "Drop rate must be greater than 0",
  nameRequired: "Campaign name is required",
  datesRequired: "Start and end date are required",
  endAfterStart: "End date must not be before start date",
  addAtLeastOneChest: "Add at least one chest",
  chestNotReady: "A reward is still 0 cent (must be greater than 0)",
  confirm: "Confirm",
  discardConfirm: "Discard changes? Unsaved edits will be lost.",
  removeChestConfirm: "Remove this chest? Its reward config will be lost.",
  chestsUnit: "chests",
  allChestsReady: "All chests ready",
  notReadySuffix: "not ready",
  fixErrors: "Please fix the highlighted fields",
};
